import { branchConstants } from "./constants/branchConstants";

const enableBranches = (data: any) => ({
  type: branchConstants.enableBranchesRequest,
  payload: data,
});

const createBranch = (data: any) => ({
  type: branchConstants.createBranchRequest,
  payload: data,
});

const listBranches = (data: any) => ({
  type: branchConstants.listBranchesRequest,
  payload: data,
});

const switchTenant = (data: any) => ({
  type: branchConstants.switchTenantRequest,
  payload: data,
});

export const branchActions = {
  enableBranches,
  createBranch,
  listBranches,
  switchTenant,
};
